import { render } from "./BlueBackground.vue?vue&type=template&id=4952a89f"
import script from "./BlueBackground.vue?vue&type=script&lang=js"
export * from "./BlueBackground.vue?vue&type=script&lang=js"

import "./BlueBackground.vue?vue&type=style&index=0&id=4952a89f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__